import { render, staticRenderFns } from "./MatchCup.vue?vue&type=template&id=667c82bb&scoped=true&"
import script from "./MatchCup.vue?vue&type=script&lang=js&"
export * from "./MatchCup.vue?vue&type=script&lang=js&"
import style0 from "./MatchCup.vue?vue&type=style&index=0&id=667c82bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667c82bb",
  null
  
)

export default component.exports